(() => {
  const SELECTOR = '[data-article-related-products-swiper]';

  function initOne(el) {
    if (!el || el.dataset.embeInit === '1') return;
    el.dataset.embeInit = '1';

    const run = () => {
      if (!window.Swiper) return false;

      const slides = el.querySelectorAll('.swiper-slide');
      if (!slides.length) return true;

      const prev = el.querySelector('.swiper-button-prev');
      const next = el.querySelector('.swiper-button-next');
      const pagination = el.querySelector('.swiper-pagination');

      const opts = {
        slidesPerView: 1.2,
        spaceBetween: 10,
        speed: 500,
        roundLengths: true,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        breakpoints: {
          640: { slidesPerView: 2 },
          1200: { slidesPerView: 3, spaceBetween: 16 },
          1600: { slidesPerView: 4, spaceBetween: 24 }
        }
      };

      if (prev && next) opts.navigation = { prevEl: prev, nextEl: next };
      if (pagination) opts.pagination = { el: pagination, clickable: true };

      try {
        // eslint-disable-next-line no-new
        new window.Swiper(el, opts);
      } catch (_) {
        el.classList.add('embe-swiper-failed');
      }

      return true;
    };

    if (run()) return;

    let tries = 0;
    const timer = setInterval(() => {
      tries += 1;
      if (run()) {
        clearInterval(timer);
        return;
      }
      if (tries >= 30) clearInterval(timer);
    }, 100);
  }

  function init(root = document) {
    root.querySelectorAll?.(SELECTOR)?.forEach?.(initOne);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();

